<template>
  <div>
    <div class="modalidade">
      <div class="container">
        <div class="row align-items-center">
          <div class="col">
            <div class="pill" :style="style.pill">
              Modalidade {{ index }}:
            </div>
            <div class="name">
              <StrongText>{{ name }}</StrongText>
            </div>
          </div>
          <div class="col text-right buttonaqui">
            <slot/>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import colors from '@/services/colors'
import StrongText from '@/components/StrongText'

export default {
  name: 'Modalidade',
  components: {
    StrongText,
  },
  props: {
    index: {
      required: true,
      type: Number,
    },
    name: {
      required: true,
      type: String,
    }
  },
  computed: {
    style() {
      return {
        pill: {
          color: colors.blue
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-right {
  text-align: right;
}
.modalidade {
  padding-top: 75px;
  padding-bottom: 75px;
  @media (max-width: 992px) {
    text-align: center;
  }
}
.line { 
  height: 1px; 
  background: #D8D8D8;
}
.pill {
  font-size: 17px;
  padding: 2px;
  background: #D8D8D8;
  border-radius: 20px;
  padding: 5px 10px;
  display: inline-block;
  margin-bottom: 18px;
}
.buttonaqui {
  @media (max-width: 992px) {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
